export default __webpack_public_path__ + "static/media/MenudsjinscampWest.b73c5f1c.jpg";